// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "client/" + ({"7934":"Viewer","7945":"AboutEditModal"}[chunkId] || chunkId) + ".chunk.min.css";
};